module.exports = __webpack_public_path__ + "static/media/29ADMSPC3.fe6e78a9.jpg";